import React, { Component } from 'react'

export class Section extends Component {
  render() {
    const { extraClasses = '', children, containerClass = '' } = this.props
    return (
      <section className={`section ${extraClasses}`}>
        <div className={`container ${containerClass}`}>{children}</div>
      </section>
    )
  }
}

export default Section
